import React from 'react';

import { Button } from 'antd';

import * as globals from '../globals';

export default () => {
  return (
    <div className="section">
      <h3 className="sectiontitle">What is Direct Primary Care?</h3>
      <br />
      <div className="sectionitem" style={{ maxWidth: '600px' }}>
        <p style={{ marginBottom: '15px' }}>
          Direct Primary Care, or DPC, is a new way of providing primary care
          that's already helped a quarter million people stay healthier and
          spend less on healthcare. Patients at DPC practices often receive
          ongoing primary care from their doctor with zero copays, convenient
          online scheduling options, near-wholesale prices on medications and
          blood tests, and even their doctor's personal cell number. It's like
          having a doctor in the family.
        </p>
        <p style={{ marginBottom: '15px' }}>
          So how is this possible? Easy: direct primary care practices cut out
          middlemen like insurance companies, freeing themselves to provide
          great care at fair prices. Unlike traditional third party practices
          that serve the needs of insurance companies, direct primary care is
          for everybody; most DPC memberships cost less than your monthly cell
          phone or cable bill, for great care whenever you need it.
        </p>
        <p style={{ marginBottom: '15px' }}>
          If you're tired of high copays, insane wait times, rushed 8-minute
          doctor visits, join 250,000 other Americans that have already
          benefited from direct primary care. Search on the{' '}
          <a href={globals.mapperURL}>DPC Mapper</a> to find a practice near
          you.
        </p>
        <div className="leftrow wrap">
          <Button href="https://dpcnation.org" target="_blank" type="primary">
            Learn More About DPC
          </Button>
        </div>
      </div>
    </div>
  );
};
